module.exports = __webpack_public_path__ + "img/arrow-down-s-line.e9941ef7.svg";